(() => {
  const widget = document.querySelector('[data-ghm-floating-search]');
  if (!widget) return;
  const toggle = widget.querySelector('[data-ghm-search-toggle]');
  const panel = widget.querySelector('#ghm-search-panel');
  const input = widget.querySelector('#model-search');
  const close = widget.querySelector('[data-ghm-search-close]');
  const phone = matchMedia('(max-width:760px)');
  let chatRoot, chatButton, previewBar, queued = false;
  const isOpen = () => toggle.getAttribute('aria-expanded') === 'true';
  function setOpen(open, restoreFocus = false) {
    const result = document.getElementById('result-count');
    widget.querySelector('[data-ghm-search-hint]').textContent = result && input.value.trim() ? result.textContent : 'Try “skid steer” or “R18”.';
    panel.hidden = !open;
    toggle.setAttribute('aria-expanded', String(open));
    if (open) input.focus({preventScroll:true});
    else if (restoreFocus) toggle.focus({preventScroll:true});
  }
  panel.hidden = true;
  toggle.hidden = close.hidden = false;
  toggle.addEventListener('click', () => setOpen(!isOpen()));
  close.addEventListener('click', () => setOpen(false, true));
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && isOpen()) {
      event.preventDefault();
      setOpen(false, true);
    }
  });
  document.addEventListener('pointerdown', event => {
    if (isOpen() && !event.composedPath().includes(widget)) setOpen(false);
  });
  document.addEventListener('focusin', event => {
    if (isOpen() && !event.composedPath().includes(widget)) setOpen(false);
  });
  widget.querySelector('form').addEventListener('submit', () => {
    if (document.querySelector('.machine-card')) setOpen(false);
  });
  input.addEventListener('input', () => {
    const result = document.getElementById('result-count');
    widget.querySelector('[data-ghm-search-hint]').textContent = result && input.value.trim() ? result.textContent : 'Try “skid steer” or “R18”.';
  });
  function position() {
    queued = false;
    const host = document.querySelector('shopify-chat');
    const runtime = host?.shadowRoot?.querySelector('shopify-agent-runtime');
    const root = runtime?.shadowRoot;
    const bar = document.getElementById('PBarNextFrameWrapper');
    if (bar && bar !== previewBar) {
      previewBar = bar;
      new ResizeObserver(schedule).observe(bar);
      new MutationObserver(schedule).observe(bar, {attributes:true, attributeFilter:['style','class']});
    }
    if (root && root !== chatRoot) {
      chatRoot = root;
      new MutationObserver(schedule).observe(root, {subtree:true, childList:true, attributes:true, attributeFilter:['aria-expanded','class','style','inert']});
    }
    const nextButton = root?.querySelector('[part="activator"]');
    if (nextButton && nextButton !== chatButton) {
      chatButton = nextButton;
      new ResizeObserver(schedule).observe(chatButton);
    }
    const chatOpen = chatButton?.getAttribute('aria-expanded') === 'true';
    host?.toggleAttribute('data-ghm-chat-open', chatOpen);
    const covered = chatOpen || !!document.querySelector('dialog[open]');
    if (covered && isOpen()) setOpen(false);
    widget.hidden = covered;
    if (covered) return;
    const rect = chatButton?.getBoundingClientRect();
    if (rect?.width && rect.height && rect.left >= 0 && rect.right <= innerWidth + 1) {
      const right = document.documentElement.clientWidth - rect.right;
      const stackStep = parseFloat(getComputedStyle(widget).getPropertyValue('--ghm-search-stack-step')) || 62;
      const bottom = document.documentElement.clientHeight - rect.bottom - stackStep;
      widget.style.right = Math.max(16, right) + 'px';
      widget.style.bottom = Math.max(16, bottom) + 'px';
    } else {
      const barRect = previewBar?.getBoundingClientRect();
      const clearance = barRect?.height ? innerHeight - barRect.top + 20 : 24;
      widget.style.right = '20px';
      widget.style.bottom = Math.max(24, clearance) + 'px';
    }
  }
  function schedule() { if (!queued) { queued = true; requestAnimationFrame(position); } }
  new MutationObserver(schedule).observe(document.body, {subtree:true, childList:true, attributes:true, attributeFilter:['open']});
  new MutationObserver(schedule).observe(document.documentElement, {attributes:true, attributeFilter:['style']});
  new ResizeObserver(schedule).observe(document.body);
  addEventListener('resize', schedule);
  visualViewport?.addEventListener('resize', schedule);
  phone.addEventListener('change', schedule);
  let attempts = 0;
  const bootstrap = setInterval(() => {
    schedule();
    if (chatButton || ++attempts >= 100) clearInterval(bootstrap);
  }, 200);
  position();
})();
